export function isBranded(categoryName) {
  return this.$pubCtx.branding && this.$pubCtx.branding.categories instanceof Array &&
   this.$pubCtx.branding.categories.includes(categoryName);
}
